export default "__VITE_ASSET__DAYVFKNi__"